<template>
    <li>
        <component
            :is="componentIs"
            v-slot="vSlot"
            :to="itemTo"
            :href="itemHref"
            :target="itemTarget"
            :class="isAsideMobile && item.img ? 'h-auto' : 'h-14'"
            class="flex cursor-pointer h-14 text-xl items-center"
            @click="menuClick"
        >
            <icon
                v-if="item.icon"
                :path="item.icon"
                :class="[vSlot && (vSlot.isExactActive || vSlot.route.matched[0]?.children.find(r => r.name === routeName)) ? styleActive : styleInactiveIcon]"
                size="30"
                :w="isAsideMobile ? 'w-20' : 'w-full'"
                h="h-full"
            />
            <div
                v-if="isAsideMobile && item.img"
                class="px-2 py-2 max-w-52"
            >
                <img :src="item.img" alt="spo+shot banner">
            </div>
            <div 
                v-else-if="isAsideMobile" 
                class="h-full w-full flex items-center whitespace-pre-line"
                :class="[vSlot && (vSlot.isExactActive || vSlot.route.matched[0]?.children.find(r => r.name === routeName)) ? styleActive : styleInactive]"
            >{{ item.label=='ノート'?(sportType=='baseball'?'野球':'成長')+item.label:item.label }}
            </div>
        </component>
        <div
            v-if="isAsideMobile && item?.submenu?.length && showSubmenuInfo.isShow"
            class="mb-4"
        >
            <div
                v-for="(menu, index) in item.submenu"
                :key="index"
            >
                <div
                    v-for="(subItems, categoryName) in menu"
                    :key="categoryName"
                    class="mx-4 mt-2 text-xl"
                >
                    <p class="text-green-500 border-b border-green-500 mr-2 mb-2">
                        {{ categoryName }}
                    </p>
                    <li
                        v-for="sub in subItems"
                        :key="sub.to"
                        class="pt-1 pl-2"
                        :class="[vSlot && vSlot.isExactActive ? styleActive : styleInactive]"
                    >
                        <router-link
                            :to="sub.to"
                            :class="{'underline text-green-500': sub.to === path}"
                            class="text-gray-700 font-medium mt-4 hover:text-green-400 hover:cursor-pointer"
                        >
                            {{ sub.label }}
                        </router-link>
                    </li>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
import { computed, defineAsyncComponent, ref } from 'vue'
import { mdiMinus, mdiPlus } from '@mdi/js'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import Icon from '@/components/Utilities/Icon'

export default {
    name: 'AsideMenuItem',
    components: {
        AsideMenuList: defineAsyncComponent(() => import('@/components/Utilities/AsideMenuList')),
        Icon
    },
    props: {
        item: {
            type: Object,
            default: () => {}
        },
        isSubmenuList: Boolean,
        isAsideMobile: {
            type: Boolean,
            default: false
        },
        showSubmenuInfo: {
            type: Object,
            default: {
                isShow: true,
                label: 'ランキング'
            },
        },
    },
    emits: ['menu-click'],
    setup (props, { emit }) {
        const route = useRoute()
        const path = computed(() => route.path)
        const routeName = computed(() => route.name)
        const isDropdownActive = ref(false)
        const componentIs = computed(() => props.item.to ? 'router-link' : 'a')
        const hasDropdown = computed(() => !!props.item)
        const dropdownIcon = computed(() => isDropdownActive.value ? mdiMinus : mdiPlus)
        const itemTo = computed(() => props.item.to || null)
        const itemHref = computed(() => props.item.href || null)
        const itemTarget = computed(() => componentIs.value === 'a' && props.item.target ? props.item.target : null)
        const store = useStore()
        const sportType = computed(() => store.state.teamData.sport_type)

        const menuClick = event => {
            emit('menu-click', event, props.item)

            if (hasDropdown.value) {
                isDropdownActive.value = !isDropdownActive.value
            }
        }
        /* const styleActive = 'font-bold text-gray-900' */
        /* const styleInactive = 'text-gray-600' */
        const styleActive = 'font-bold text-white active-color'
        const styleInactive = 'font-medium inactive-custom-style'
        const styleInactiveIcon = 'inactive-icon-custom-style'

        return {
            isDropdownActive,
            componentIs,
            hasDropdown,
            dropdownIcon,
            itemTo,
            itemHref,
            itemTarget,
            menuClick,
            styleActive,
            styleInactive,
            styleInactiveIcon,
            path,
            routeName,
            sportType
        }
    }
}
</script>

<style>
.active-color {
    background-color: #00AF5B;
}

.inactive-custom-style {
    color: #111827;
}

.inactive-icon-custom-style {
    color: #00AF5B;
}

.text {
    line-height: 56px;
}
</style>
